module.exports = __webpack_public_path__ + "static/media/destination-weddings-honeymoons.90e16a2d.jpg";